package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError


@Serializable
data class TemplateCategoryDetailModel(
    @SerialName("data")
    val data: Data?=null,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)